import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { createQuotationsMockData } from './quotations.mock';
import { Summary } from './types';

@Component({
  selector: 'dashboard-quotations',
  templateUrl: './quotations.component.html',
  styleUrls: ['./quotations.component.scss']
})
export class DashboardQuotationsComponent implements OnInit {
  summary: Summary = {
    open: { count: 0, totalPrice: 0 },
    expiringSoon: { count: 0, totalPrice: 0, withinDays: 30 },
    accepted: { count: 0, totalPrice: 0 }
  }

  constructor(private Router: Router) { }

  ngOnInit(): void {
    const mockData = createQuotationsMockData();
    this.summary = mockData.summary;
  }

  showQuotations(): void {
    this.Router.navigateByUrl('quotations');
  }
}
